// This import loads the firebase namespace along with all its type information.
import MediaLog from './media-log-model'

export async function load_mediaLogs(): Promise<MediaLog[]> {
  throw 'Not implemented'
}

export async function delete_mediaLog(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediaLog(): Promise<MediaLog> {
  throw 'Not implemented'
}
